module.exports = __webpack_public_path__ + "static/video_bg_01-b9d08d9dbab875ba99c8e18bc639f07a.png";